import { SetStateAction, useEffect, useState } from "react";
import { NavDropdown } from "react-bootstrap";

export interface Props<T> {
  label: string;
  keyProvider: (item: T) => string;
  labelProvider: (item: T) => string;
  dataProvider: () => Promise<T[]>;
  initialValue?: T | string;
  onChange: (selection?: T) => void;
  disabled: boolean;
  required: boolean;
  changeSelectionKey?: string
}

export const CommonDropdown = <T,>({
  label,
  keyProvider,
  labelProvider,
  dataProvider,
  initialValue,
  onChange,
  disabled,
  required,
  changeSelectionKey
}: Props<T>) => {
  const [loading, setLoading] = useState<boolean>();

  const [data, setData] = useState<T[]>([]);
  const [selection, setSelection] = useState<T>();

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const data = await dataProvider();
        await setData(data);

        if (!initialValue) {
          setSelection(undefined);
          return;
        }
        if (typeof (initialValue) == 'string') {
          const selectedItem = data.find((i) => keyProvider(i) === initialValue);
          setSelection(selectedItem);
          onChange(selectedItem);
        } else {
          setSelection(initialValue as T);
        }
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const onValueChange = (selectedKey: string) => {
    const selectedItem = data.find((i) => keyProvider(i) === selectedKey);
    setSelection(selectedItem);
    onChange(selectedItem);
  };

  useEffect(()=>{
    if(changeSelectionKey){
      const selectedItem = data.find((i) => keyProvider(i) === changeSelectionKey);
      setSelection(selectedItem)
    }
  },[changeSelectionKey])

  return (
    <>
      <select
        className="form-select form-select-sm "
        name="taskTypeId"
        value={selection ? keyProvider(selection) : undefined}
        onChange={(e) =>  onValueChange(e.target.value) }
        disabled={disabled}
        required={required}
      >
        <option value="">
          Select {label}
        </option>
        {loading && <option className="pt-3 text-center">Loading...</option>}
        {data.map((row: T, index: number) => (
          <option key={index} value={keyProvider(row)}>
            {labelProvider(row)}
          </option>
        ))}
      </select>
    </>
  );
};
